import { colors } from '@material-ui/core';

export default {
  contained: {
    height: '36px',
  }
};
